import { render, staticRenderFns } from "./AllowedGroups.vue?vue&type=template&id=1e241c9b&scoped=true"
import script from "./AllowedGroups.vue?vue&type=script&lang=js"
export * from "./AllowedGroups.vue?vue&type=script&lang=js"
import style0 from "./AllowedGroups.vue?vue&type=style&index=0&id=1e241c9b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e241c9b",
  null
  
)

export default component.exports